import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconSend = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M11.1538 0.075705L0.292674 6.34163C-0.131459 6.58534 -0.0775638 7.17584 0.344226 7.35393L2.83513 8.39903L9.56737 2.46585C9.69625 2.35103 9.87903 2.52678 9.7689 2.66034L4.12394 9.53787V11.4242C4.12394 11.9772 4.79177 12.1951 5.11983 11.7944L6.60781 9.98309L9.52754 11.2063C9.86028 11.3469 10.2399 11.1383 10.3008 10.7798L11.988 0.656838C12.0677 0.183496 11.5592 -0.158623 11.1538 0.075705Z"
	})
});
export default SvgIconSend;
